<template lang="jade">
  div.Lightbox.Lightbox--open(v-if="loading"
                              class="animated"
                              transition="fade")
    spinner(":loading.sync"="loading")
  div(":skin"="skins.app")
    fg-header(":content"="workflow.header")
    fg-body(":fragments"="workflow.body"
            ":layout"="workflow.layout"
            ":uid"="uid")
    fg-footer(":content"="workflow.footer")
</template>

<script>
// import _ from 'lodash'
import fragment from 'src/components/fragments/set'
import header from 'src/components/fragments/partials/header'
import footer from 'src/components/fragments/partials/footer'
import spinner from 'src/components/loaders/spinner'
import { Workflows } from 'src/services/resources'
import { addWorkflow,
         clearAllNotifications } from 'src/vuex/actions'
import { workflow,
         skins,
         forms } from 'src/vuex/getters'

export default {
  data () {
    return {
      loading: false,
      uid: ''
    }
  },
  props: {
    workflow: {
      type: Object,
      required: true
    }
  },
  vuex: {
    actions: {
      addWorkflow,
      clearAllNotifications
    },
    getters: {
      head: workflow,
      skins,
      forms
    }
  },

  components: {
    'fg-header': header,
    'fg-body': fragment,
    'fg-footer': footer,
    spinner
  },
  methods: {
    swap (workflow) {
      let uid = this.createUID(workflow.body[0].content[0].currentFragmentId)
      this.$set('uid', uid)
      this.clearAllNotifications()
      this.addWorkflow({fid: workflow.id,
                        fingerprint: workflow.fingerprint,
                        sid: this.$parent.sid,
                        uid: uid})
      this.$set('workflow', workflow)
      setTimeout(() => {
        this.$set('loading', false)
      }, 800)
    },

    success (res) {
      let workflow = res.data.content
      workflow.fingerprint = res.data.fingerprint
      this.swap(workflow)
    },

    fail (res) {
      let msg = _.has(res.data, 'user_message') ? res.data.user_message : 'Internal error'
      this.addNotification({type: 'error',
                            msg: [msg],
                            id: _.uniqueId(),
                            timeout: 5000,
                            onComplete: 'remove',
                            show: true})
    },

    loader (x) {
      this.$set('loading', x)
    },

    newWindow (wid, uid, params) {
      Workflows.get(wid, params, this.headers(uid))
        .then(res => {
          localStorage.setItem('new::window', JSON.stringify(res))
          window.open(window.location.href, '_blank')
        })
        .catch(this.fail)
    },

    headers (uid) {
      let workflow = _.find(this.head, ['uid', uid])
      let {fid, fingerprint, sid} = workflow
      return { headers: {
        'X-FORMID': fid,
        'X-FINGERPRINT': fingerprint,
        'X-SITEID': sid
      }}
    },

    fetch (wid, uid, params) {
      Workflows.get(wid, params, this.headers(uid))
        .then(this.success)
        .catch(this.fail)
    }
  },
  events: {
    'add::workflow': 'swap',
    'replace::workflow': 'fetch',
    'loader::spinner': 'loader',
    'tab::workflow': 'newWindow'
  },

  created () {
    let uid = this.createUID(this.workflow.body[0].content[0].currentFragmentId)
    this.$set('uid', uid)
    this.addWorkflow({fid: this.workflow.id,
                      uid: uid,
                      fingerprint: this.$parent.fingerprint,
                      sid: this.$parent.sid})
  }
}
</script>



// WEBPACK FOOTER //
// workflow.vue?48e3220c